import { SET_TENANTS_ACTION } from "./reducersConstants";

export const setTenantsAction = (data) => {
  return {
    type: SET_TENANTS_ACTION,
    data,
  };
};

export const tenantsReducer = (previousState = [], { type, data }) => {
  switch (type) {
    case SET_TENANTS_ACTION:
      return data;
    default:
      return previousState;
  }
};
